import Text from '@ingka/text';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import { Stack, Page } from 'components/layout';
import React, { ChangeEvent, useState, useEffect } from 'react';
import FormField from '@ingka/form-field';
import Button from '@ingka/button';
import styled from 'styled-components';
import { DetailPage } from 'pages/Detail/Detail';
import { useLocation, useNavigate } from 'react-router-dom';
import documentAdd from '@ingka/ssr-icon/paths/document-add';
import Pill from '@ingka/pill';
import { convertFileToBase64 } from 'utils/common';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import { euFileUpload, resetFileUpload } from 'Action/euFileUploadAction';
import Toast from '@ingka/toast';
import InlineMessage from '@ingka/inline-message';
import { Select, Option } from '@ingka/select';
import { masterDataManual } from 'Action/manualDropDownAction';
import './fileUpload.scss';

const FileUploadTemplate = styled.div`
  display: flex;
  flex-direction: column;
  // width: min-content;
`;
const ButtonDiv = styled.div`
  margin-left: 40px;
`;

export const FileUpload = () => {
  const [euSupplierId, setEuSupplierId] = useState('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [byteStreamData, setByteStreamData] = useState<any>();
  const [toastOpen, setToastOpen] = useState<any>(false);
  const [hasNavigated, setHasNavigated] = useState(false);
  const [activeTab, setActiveTab] = useState('tab_1');
  const [toastMessage, setToastMessage] = useState('');
  const [inlineMessage, setInlineMessage] = useState('');
  const [inlineMessageVisible, setInlineMessageVisible] = useState(false);
  const [errorInlineMessage, setErrorInlineMessage] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { euFileUploadData } = useSelector((state: RootState) => state.euFileUploadDetails);
  const { masterData } = useSelector((state: RootState) => state.dropDownMasterData);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    dispatch(masterDataManual());
  }, []);
  useEffect(() => {
    if (location.pathname === '/eusuppliers/fileupload') {
      setHasNavigated(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (toastOpen && !hasNavigated && euFileUploadData?.success === 'True') {
      const timer = setTimeout(() => {
        setHasNavigated(true);
        navigate('/eusuppliers');
        setTimeout(() => {
          setHasNavigated(false);
          // setToastOpen(false);
          setErrorInlineMessage(false);
        }, 6000);
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [toastOpen, hasNavigated, euFileUploadData, navigate]);

  const handleEuSupplierChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setEuSupplierId(event.target.value as string);
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(resetFileUpload());
    if (event.target.files) {
      const file = event.target.files[0];
      const fileExtension = file?.name.slice(file.name.lastIndexOf('.') + 1) || '';
      setSelectedFile(event.target.files[0]);
      const byteStream = await convertFileToBase64(file);
      setByteStreamData(byteStream);
      setByteStreamData({
        fileBytes: byteStream,
        fileType: fileExtension,
      });
      // event.target.value = null;
    }
  };

  const handleJsonTemplate = () => {
    const filePath = '/JSON_Template.json';
    const a = document.createElement('a');
    a.href = filePath;
    a.download = '/JSON_Template.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleSubmit = async () => {
    setToastOpen(false);
    setHasNavigated(false);
    setErrorInlineMessage(false);

    try {
      const response = await dispatch(euFileUpload(byteStreamData, euSupplierId));
      const responseData = response?.data;

      if (responseData?.success === 'True' && responseData.data?.fedsaReferenceNumber) {
        setToastMessage(
          `Success: successfully submitted.\nFRN ID: ${responseData.data.fedsaReferenceNumber}`
        );
        setShowSuccessMessage(true);
      } else {
        const errors = responseData?.errors;
        let errorMessage = responseData?.message || 'File upload failed';

        if (Array.isArray(errors)) {
          const detailedErrors = errors.map((err: any) => `• ${err.message}`).join('\n\n');

          errorMessage += `\n\n${detailedErrors}`;
        }

        setToastMessage(`Error: ${errorMessage}`);
        setShowErrorMessage(true);
        dispatch(resetFileUpload());

        return (
          <p style={{ fontFamily: 'Arial, sans-serif', whiteSpace: 'pre-line', color: 'red' }}>
            {errorMessage}
          </p>
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Error: Network or server error';

      setToastMessage(`Error:${errorMessage}`);
      setShowErrorMessage(true);
      dispatch(resetFileUpload());
    }

    setToastOpen(true);
    // setErrorInlineMessage(true);
  };

  const onClose = () => {
    setToastOpen(false);
    if (toastMessage.startsWith('Error:')) {
      window.location.reload();
    }
  };

  const tabs = [<Tab key="tab-1" text={'File Upload'} tabPanelId="tab_1" />];

  const tabPanels = [
    <TabPanel key="tab-1" tabPanelId="tab_1">
      <div style={{ width: 'auto' }}>
        <div style={{ width: 'auto', paddingBottom: 20 }}>
          <Select
            className="supplier-div"
            id="supplierId"
            label="Supplier Name"
            value={euSupplierId}
            onChange={handleEuSupplierChange}
          >
            {masterData?.supplierMaster &&
              masterData?.supplierMaster.map((data: any) => (
                <Option key={data.supplierName} value={data.supplierId} name={data.supplierName} />
              ))}
          </Select>
        </div>
      </div>
      <FormField>
        <input type="file" onChange={handleFileChange} accept=".json" />
      </FormField>
      <FileUploadTemplate style={{ width: 200 }}>
        <Pill
          size="small"
          label="Json file template"
          onClick={handleJsonTemplate}
          leadingIcon={documentAdd}
          style={{ marginBottom: '10px', borderRadius: '0px' }}
        />
      </FileUploadTemplate>

      <ButtonDiv>
        {selectedFile ? (
          <Button
            iconPosition="leading"
            key="submit"
            size="small"
            text="Submit"
            type="emphasised"
            onClick={handleSubmit}
          ></Button>
        ) : (
          <Button
            iconPosition="leading"
            key="submit"
            size="small"
            text="Submit"
            type="emphasised"
            disabled
          ></Button>
        )}
      </ButtonDiv>
    </TabPanel>,
  ];

  const handleCopy = () => {
    const frn = euFileUploadData?.data?.fedsaReferenceNumber;

    if (frn) {
      navigator.clipboard
        .writeText(frn)
        .then(() => {
          setInlineMessage('FRN copied to clipboard');
          setInlineMessageVisible(true);
        })
        .catch(() => {
          setInlineMessage('Failed to copy FRN');
          setInlineMessageVisible(true);
        });
    }
  };

  return (
    <>
      {hasNavigated ? (
        <DetailPage />
      ) : (
        <Page className="file-upload-container" style={{ marginLeft: 20, maxWidth: 'fit-content' }}>
          <Tabs tabs={tabs} tabPanels={tabPanels} defaultActiveTab={activeTab} />
        </Page>
      )}

      {showSuccessMessage && (
        <div className="error-inline-message">
          <InlineMessage
            title="Notification"
            variant="positive"
            dismissable
            onDismissClick={onClose}
            body={
              <div className="inline-message__body">
                {toastMessage.split('\n').map((line, index) => {
                  if (line.includes('FRN ID:')) {
                    const frnId = line.split('FRN ID:')[1]?.trim();
                    return (
                      <div key={index}>
                        FRN ID: {frnId}
                        <button className="inline-message__copy-btn" onClick={handleCopy}>
                          <span className="btn__label">Copy</span>
                        </button>
                      </div>
                    );
                  }
                  return <div key={index}>{line}</div>;
                })}
              </div>
            }
          />
        </div>
      )}

      {showErrorMessage && (
        <div className="error-inline-message">
          <InlineMessage
            title="Error"
            variant="negative"
            dismissable
            onDismissClick={onClose}
            body={<div style={{ whiteSpace: 'pre-wrap' }}>{toastMessage}</div>}
          />
        </div>
      )}

      {inlineMessageVisible && (
        <InlineMessage
          className="inline-message--bottom-right"
          title="Notification"
          variant="positive"
          dismissable
          body={inlineMessage}
        />
      )}
    </>
  );
};
